module.exports = __webpack_public_path__ + "img/Lockheed_Martin-Logo 1.fbe85d11.svg";